<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 5L3 19C3 20.1046 3.89543 21 5 21L19 21C20.1046 21 21 20.1046 21 19L21 5C21 3.89543 20.1046 3 19 3L5 3C3.89543 3 3 3.89543 3 5Z"
      stroke="currentColor"
      stroke-width="1.75"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.563 13.9799H11.5697"
      stroke="currentColor"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.5643 11.2575C16.5643 10.5741 15.8765 10.0201 15.028 10.0201C14.1796 10.0201 13.4918 10.5741 13.4918 11.2575V12.7424C13.4918 13.4259 14.1796 13.9799 15.028 13.9799C15.8765 13.9799 16.5643 13.4259 16.5643 12.7424V11.2575Z"
      stroke="currentColor"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.4357 11.0101L9.27922 10.0201V13.9799"
      stroke="currentColor"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default { name: 'Number' };
</script>

<style scoped lang="scss" type="text/scss">

</style>
